// extracted by mini-css-extract-plugin
export default {"shortText":"PlaygroundTokenUsageWidget-module__shortText--yKbO8","longText":"PlaygroundTokenUsageWidget-module__longText--C9wgy"};